module.exports = __webpack_public_path__ + "static/media/03.fd12965e.png";